import { useEffect } from 'react'
import { DropdownCarsContext } from 'entities/Billing/ui/DropdownCards/context/DropdownCars'
import { type DropdownCardsStore } from 'entities/Billing/ui/DropdownCards'
import { DropdownCardsUi } from './DropdownCardsUi'

type IDropdownCardsProps = {
  store: DropdownCardsStore
}

export const DropdownCards = ({ store }: IDropdownCardsProps) => {
  useEffect(() => {
    store.loadSources()
  }, [])

  return (
    <DropdownCarsContext.Provider value={store}>
      <DropdownCardsUi />
    </DropdownCarsContext.Provider>
  )
}
